<template>
  <aside>
    <div id="sidebar" class="nav-collapse" :style="navscreen">
      <div class="sideBHolder"></div>
      <div id="nav-container" v-on:click="expandnav()" v-bind:class="[isexpand ? 'pushed' : '']">
        <div class="toggle-icon">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
      </div>
      <ul class="sidebar-menu" id="nav-accordion">
        <li class="sub-menu cursor-pointer" title="Home">
          <router-link :to="'/'">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-house" />
            <span v-show="isexpand" class="marL10">Home</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" title="Setup">
          <router-link :to="'/setup/' + asgId" :class="{ 'landactive': navactive == 1 }">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-sliders" />
            <span v-show="isexpand" class="marL10">Setup</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" title="Tagging" v-show="nexSteps == true">
          <router-link :to="'/TaggingPage/' + asgId" :class="{ 'landactive': navactive == 6 }">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-circle-nodes" />
            <span v-show="isexpand" class="marL10">Auto Tagging</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" title="Data Quality & Profiling" v-show="nexSteps == true">
          <router-link :to="'/dataset/' + asgId" :class="{ 'landactive': navactive == 2 }">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-award" />
            <span v-show="isexpand" class="marL10">Data Quality & Profiling</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" title="Insights" v-show="nexSteps == true">
          <router-link :to="'/insights/' + asgId" :class="{ 'landactive': navactive == 3 }">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-magnifying-glass-chart" />
            <span v-show="isexpand" class="marL10">Insights & Dashboards</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" title="Inquisight" v-show="nexSteps == true">
          <router-link :to="'/inquisight/' + asgId" :class="{ 'landactive': navactive == 5 }">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-comments" />
            <span v-show="isexpand" class="marL10">Inquisight</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" title="Storyboard" v-show="nexSteps == true">
          <router-link :to="'/slideMode/' + asgId" :class="{ 'landactive': navactive == 4 }">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-person-chalkboard" />
            <span v-show="isexpand" class="marL10">Storyboard</span>
          </router-link>
        </li>
        <li class="sub-menu cursor-pointer" :title="$store.state.assDetails.isAppmToShow?'APPM':'To enable APPM Feature,Tower column should be mapped during data upload.'" v-show="nexSteps == true" >
          <router-link :to="'/appmHome/' + asgId" :class="{ 'landactive': navactive == 7, 'disabled': !$store.state.assDetails.isAppmToShow}">
            <font-awesome-icon class="leftMenuIcon" icon="fa-solid fa-sun" />
            <span v-show="isexpand" class="marL10">APPM</span>
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>
<script>
import {
  useRoute
} from 'vue-router';
export default {
  name: 'navMenu',
  props: {
    navactive: Number
  },
  data() {
    return {
      asgId: undefined,
      isexpand: false,
      navscreen: {
        width: "45px"
      },
    }
  },
  methods: {
    expandnav() {
      this.isexpand = !this.isexpand
      this.navscreen = (this.navscreen.width == "45px") ? {
        width: "260px"
      } : {
        width: "45px"
      }
      this.$emit("expandnav")
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
  },
  computed: {
    TClrs() {
      return this.$store.state.TClrs
    },
    nexSteps() {
      return this.$store.state.nexSteps
    }
  },
}
</script>
<style scoped>
#nav-container {
  position: relative;
  transform: rotate(0deg);
  transition: .5s ease-in-out;
  left: -20px;
  cursor: pointer;
  height: 75px;
  width: 75px;
  transform: scale(0.5);
  top: -23px;
}

#nav-container.pushed {
  top: -33px;
  left: -15px;
}

.marL10 {
  margin-left: 10px;
}

.leftMenuIcon {
  width: 45px;
  text-align: center;
}

.toggle-icon {
  display: block;
  transition: margin 600ms;
  cursor: pointer;
  height: 100%;
  width: 100%;
}

.toggle-icon .bar {
  display: block;
  width: 60px;
  height: 4px;
  margin: 15px;
  border-right: 45px solid #fff;
  border-left: 10px solid #333;
  box-sizing: border-box;
  -webkit-transition-property: -webkit-transform, margin, border-right-color, box-shadow;
  -moz-transition-property: -moz-transform, margin, border-right-color, box-shadow;
  transition-property: transform, margin, border-right-color, box-shadow;
  -webkit-transition-duration: 600ms;
  -moz-transition-duration: 600ms;
  transition-duration: 600ms;
}

.toggle-icon .bar:nth-of-type(1) {
  -webkit-transition: opacity 300ms;
  -moz-transition: opacity 300ms;
  transition: opacity 300ms;
}

.toggle-icon .bar:nth-of-type(2) {
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
}

.pushed .bar:nth-of-type(1) {
  opacity: 0;
}

.pushed .bar:nth-of-type(2) {
  margin-left: 1.4em;
  -webkit-transform: rotate(-137deg) translateY(-1.15em);
  -moz-transform: rotate(-137deg) translateY(-1.5em);
  -ms-transform: rotate(-137deg) translateY(-1.15em);
  -o-transform: rotate(-137deg) translateY(-1.15em);
  transform: rotate(-137deg) translateY(-1.15em);
}

.pushed .bar:nth-of-type(3) {
  margin-left: 0.5em;
  -webkit-transform: rotate(-42deg);
  -moz-transform: rotate(-42deg);
  -ms-transform: rotate(-42deg);
  -o-transform: rotate(-42deg);
  transform: rotate(-42deg);
}

.pushed .toggle-icon:hover .bar:nth-of-type(2) {
  border-right-color: #e9b8b9;
  box-shadow: 0.4em 0 0.6em 0.1em rgba(205, 40, 44, 0.75);
}

.pushed .toggle-icon:hover .bar:nth-of-type(3) {
  border-right-color: #ddf1da;
  box-shadow: 0.4em 0 0.6em 0.1em rgba(83, 228, 68, 0.65);
}

.sideBHolder {
  width: 45px;
  height: 42px;
  position: absolute;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>